

import {  useCallback, } from "react";
import { Chip, Stack } from '@mui/material';
import { useCommonStyles } from '../../styles/GenericStyle';
import CloseIcon from '@mui/icons-material/Close';
interface ShowFilterChipsProps {
    filterValues?: any[],
    onDelete: (params: any) => void,
    
}
const ShowFilterChips = ({ filterValues = [],onDelete }: ShowFilterChipsProps) => {
    const classes = useCommonStyles();
    const handleDelete = useCallback((filter: any) => () => {
        console.log("Deleting filter:", filter);
        onDelete(filter);
    }, [onDelete]);

   


    return (

        <Stack
            direction="row"
            flexWrap="wrap"
            alignItems="flex-start"
            sx={{ mb: 2, gap: 1, alignContent: 'flex-start' }}>
            {filterValues?.map((filter: any) => (
               
                <Chip className={classes.labelNoto14Bold400}
                    label={< span className="filterData-chip-lable" > {filter.lable}: <b>{filter.value}</b></span >}
                    title={filter.value}
                    key={filter?.name}
                    deleteIcon={<CloseIcon />}
                    onDelete={handleDelete(filter)}
                    sx={() => ({
                        borderRadius: '20px',
                        backgroundColor: '#DCF8D8',
                        maxWidth: 200,
                        justifyContent: 'flex-start',
                        overflow: 'hidden',
                        border: "0.5px solid  #00AC4F",
                        '& .MuiChip-label': {
                            maxWidth: 200,
                            textAlign: 'left',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            lineHeight: 1.5,

                        },
                        '& .MuiChip-deleteIcon': {
                            marginLeft: 'auto',
                            marginRight: '10px',
                            fontSize: '16px',
                            color: 'black',
                            '&:hover': 'black',
                            '&.Mui-focusVisible': { outline: 'none' },
                        },

                    })} />
                     ))}
    

        </Stack>







    );
};

export default ShowFilterChips;
